import React from 'react';

import ZoomControl from './ZoomControl';
import { Props as MapProps } from '../index';
import { MyLocation } from './MyLocation';

const Controls = ({ showZoomControl, showLocationControl }: Props) => (
  <>
    <MyLocation showLocationControl={showLocationControl} />
    <ZoomControl showZoomControl={showZoomControl} />
  </>
);

export interface Props extends Pick<MapProps, 'showZoomControl' | 'showLocationControl'> {}

export default Controls;
